//angular
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from '../../../../_shared/animations';

@Component({
  selector: 'panel-help',
  templateUrl: './panel-help.component.html',
  animations: [AppAnimations]
})

export class PanelHelpComponent {
  status: boolean = false;
  statusPanel: string = 'isHidden';

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {
    this._iconRegistry.addSvgIcon('ico-help-doc', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-docs.svg'));
    this._iconRegistry.addSvgIcon('ico-help-api', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-api.svg'));
    this._iconRegistry.addSvgIcon('ico-help-faq', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-faq.svg'));
    this._iconRegistry.addSvgIcon('ico-help-contactus', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-contactus.svg'));
    this._iconRegistry.addSvgIcon('ico-help-callback', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-callback.svg'));
  }

  closePanel() {
    if (this.statusPanel == 'isVisible' && !this.status) {
      this.statusPanel = 'isHidden'
    } else {
      this.status = false;
    }
  }

  toggle() {
    this.status = !this.status;
    this.statusPanel = (this.statusPanel == 'isHidden' ? 'isVisible' : 'isHidden');
  }

}
